//@flow
import * as React from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import ContainerRowSpace from '@lesofi/phoenix-react-js/lib/ContainerRowSpace'
import ContainerRowTitle from '@lesofi/phoenix-react-js/lib/ContainerRowTitle'
import ContainerRowError from '@lesofi/phoenix-react-js/lib/ContainerRowError'
import ContainerRowInstructionLink from '@lesofi/phoenix-react-js/lib/ContainerRowInstructionLink'
import InvoiceHeaderContainer from './InvoiceHeaderContainer'

const InvoiceDataExtractionForm = props => {
    const { location } = props;
    const query = queryString.parse(location.search);
    
    if (!query.jwt || !query.docUrl || !query.taskAcceptedInfoId ) {
        return (
            <div className="container">
               <ContainerRowSpace />
               <ContainerRowTitle title={'Invoice Data Extraction'} />
               <ContainerRowError errorMsg={'Missing Parameters!'} /> 
            </div>
        )
    }
    
    return (
        <div className="container">
            <ContainerRowSpace />
            <ContainerRowTitle title={'Invoice Data Extraction'} />
            <ContainerRowInstructionLink docLink={query.docUrl} instructionLink={'https://docs.google.com/document/d/e/2PACX-1vSx-2wtxqUXIZ03CTqJfXBq9TYUQ_N864V4lL74uEPRwv056TxuPrvmBcMIwKvY3WIuI4qv1iVTnIpQ/pub?embedded=true'} />
            <InvoiceHeaderContainer query={query}/>
        </div>
    )
}

const mapStateToProps = (state, ownProps) => {
    return {
        theia: state.theia
    }
}

export default connect(mapStateToProps)(InvoiceDataExtractionForm);


// WEBPACK FOOTER //
// ./src/views/ProjectTheia/InvoiceDataExtractionForm.js